export type EmptyLayoutProps = { children: JSX.Element };

const EmptyLayout = ({ children }: EmptyLayoutProps) => children;

export default EmptyLayout;
